import { ClientType } from '../types';
import { KvkInformationType } from '../types/kvk-information.types';
import { Transformer } from './transformers';

export const toClientTypeFromKvkInformationTransformer: Transformer<KvkInformationType, Partial<ClientType>> = {
  transform: (kvkInformation) => {
    if (!kvkInformation) {
      return null;
    }

    return {
      name: kvkInformation.name,
      address: `${kvkInformation.street} ${kvkInformation.streetNumber}`,
      zipCode: kvkInformation.zipCode,
      city: kvkInformation.town,
    };
  },
};
